import PermIdentity from '@material-ui/icons/PermIdentity';
import {Customers} from "./Customers";
import {UniversalEdit} from "../../pagesUniversal/universalView/UniversalEdit";
import {UniversalCreate} from "../../pagesUniversal/universalView/UniversalCreate";

// import {
//     ShowGuesser,
//     // EditGuesser
// } from 'react-admin';


// import {BaseListIdNameEdit} from "./BaseListIdNameEdit";
// import {BaseListIdNameCreate} from "./BaseListIdNameCreate";

const resource = {
    list: Customers,
    create: UniversalCreate,
    edit: UniversalEdit,
    // show: ShowGuesser,
    icon: PermIdentity,
};

export default resource;